module.exports = __webpack_public_path__ + "static/media/request_behalf_right.b5672842.svg";